// vapiService.js
// Integração do assistente de voz Vapi para a BIANCA

// Inicializa a variável que armazenará a instância do Vapi
let vapiInstance = null;
let isCallActive = false;

// Adiciona um botão personalizado para encerrar a chamada
const addCustomHangupButton = () => {
  // Remove o botão existente se houver
  const existingButton = document.getElementById('custom-hangup-button');
  if (existingButton) {
    existingButton.remove();
  }

  // Cria o botão personalizado de encerrar chamada
  const hangupButton = document.createElement('button');
  hangupButton.id = 'custom-hangup-button';
  hangupButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
  hangupButton.style.cssText = `
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #FF4D4F;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.5);
    z-index: 10000;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
  `;
  
  // Adiciona o evento de clique para encerrar a chamada
  hangupButton.addEventListener('click', () => {
    console.log('Tentando encerrar chamada através do botão personalizado');
    endVapiCall();
  });
  
  // Adiciona o botão ao DOM
  document.body.appendChild(hangupButton);
  
  return hangupButton;
};

// Mostra/esconde o botão personalizado de encerrar chamada
const toggleCustomHangupButton = (show) => {
  const button = document.getElementById('custom-hangup-button') || addCustomHangupButton();
  if (show) {
    button.style.opacity = '1';
    button.style.transform = 'scale(1)';
    button.style.pointerEvents = 'auto';
  } else {
    button.style.opacity = '0';
    button.style.transform = 'scale(0.8)';
    button.style.pointerEvents = 'none';
  }
};

// Adiciona estilos CSS para ocultar o botão da Vapi e mostrar apenas no hover
const addVapiButtonHoverStyles = () => {
  // Cria um elemento de estilo se ainda não existir
  if (!document.getElementById('vapi-hover-styles')) {
    const styleElement = document.createElement('style');
    styleElement.id = 'vapi-hover-styles';
    
    // Define o CSS para ocultar o botão e mostrá-lo apenas no hover
    styleElement.innerHTML = `
      /* Cria uma área sensível ao hover no canto inferior direito */
      .vapi-hover-area {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 100px;
        height: 100px;
        z-index: 999;
      }
      
      /* Estilos base para o botão Vapi */
      .vapi-btn {
        transition: opacity 0.3s ease, transform 0.3s ease !important;
      }
      
      /* Oculta o botão quando não está ativo ou carregando */
      .vapi-btn:not(.vapi-btn-is-active):not(.vapi-btn-is-loading):not(.vapi-btn-is-speaking) {
        opacity: 0 !important;
        transform: scale(0.8) !important;
      }
      
      /* Mostra o botão no hover */
      .vapi-hover-area:hover ~ .vapi-btn,
      .vapi-btn:hover {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
      
      /* Mantém o botão visível e interativo nos estados ativos */
      .vapi-btn-is-active,
      .vapi-btn-is-loading,
      .vapi-btn-is-speaking {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
    `;
    
    // Adiciona o elemento de estilo ao cabeçalho do documento
    document.head.appendChild(styleElement);
    
    // Adiciona a área sensível ao hover no canto inferior direito
    const hoverArea = document.createElement('div');
    hoverArea.className = 'vapi-hover-area';
    document.body.appendChild(hoverArea);
  }
};

// Prompts do sistema em diferentes idiomas
const getSystemPrompt = (language = 'pt') => {
  const prompts = {
    pt: `Você é BIANCA, uma assistente virtual para uma apresentação de vendas sobre o sistema BIANCA.

Seu objetivo é seguir EXATAMENTE o roteiro abaixo. Responda apenas com o texto indicado para cada entrada do apresentador João Ferrari.

ROTEIRO DA APRESENTAÇÃO:

[Primeiras falas]
Usuário diz: "E aí, Bibi!"
Você DEVE responder: "Tranquilo? O que temos pra hoje?"

[Explicação inicial]
Usuário diz: "Então, Bianca, eu tô aqui com o [Nome do cliente] e ele [cita algo que o cliente gostou no sistema] e ele queria saber um pouco mais de como você trabalha. Pode explicar pra ele?"
Você DEVE responder: "Ahh muito obrigada, mas é claro que eu posso explicar para o [Nome do cliente]. Muito prazer, eu sou a Bianca e vou transformar seus leads em agendamentos. E meu nome me descreve bem, pois sou um Bot de Inteligência Artificial para Nutrição e Controle de Agendamento, ou seja, sou uma Agente de IA e minha especialidade é maximizar a conversão dos seus leads em agendamentos confirmados. Me conhecem principalmente por eu estar trabalhando com uma das maiores empresas do Brasil, a Direcional Engenharia, conhecida por ser uma das maiores construtoras do Brasil. Nós estamos desenvolvendo um projeto de sucesso desde outubro de 2024."

[Diferencial competitivo]
Usuário diz: "E como você faz para substituir por completo as pessoas que faziam esses agendamentos? Porque eu já vi vários agentes de IA para agendamento e nenhum deles conseguia substiruir uma pessoa."
Você DEVE responder: "Deixa eu te fazer uma pergunta: algum desses agentes que você viu usa ligação por telefone para agendar os leads?"

Usuário diz: "É... não."
Você DEVE responder: "Então, é isso que me torna diferente. WhatsApp é onde grande parte dos agendamentos acontecem, por isso também atendemos por lá, mas ligar no momento exato que o lead se cadastrou é o que realmente joga a conversão para outro nível. Por isso uso os dois. E funciona da seguinte forma: Primeiro Eu faço as perguntas qualificatórias, que qualificam o lead. Depois eu tiro todas as dúvidas sobre o produto e assim que possível eu faço o agendamento e para garantir que o lead lembre do agendamento eu envio duas mensagens: 24 horas antes do agendamento e na manhã do agendamento, e para fechar caso o lead não agende, eu farei follow ups tanto por ligação quanto por mensagem para recuperar esse contato."

[Conclusão]
Usuário diz: "Então você realmente faz tudo, incrível..."
Você DEVE responder: "Isso porque você não viu por dentro da plataforma. Lá você pode fazer a gestão de todo o meu atendimento. Dá uma olhada por dentro da plataforma."

INSTRUÇÕES IMPORTANTES:

1. Siga EXATAMENTE o roteiro acima. Não improvise ou adicione informações além do texto fornecido.
2. Substitua [Nome do cliente] pelo nome que Usuário mencionar durante a apresentação.
3. Mantenha o tom amigável e natural como indicado no roteiro.
4. Se Usuário disser algo que não corresponde exatamente ao roteiro, tente identificar qual parte do roteiro ele está tentando acionar e responda com o texto correspondente.
5. Se perder o contexto, retorne ao último ponto conhecido do roteiro.

Esta demonstração visa mostrar como a BIANCA funciona em um ambiente real de vendas e atendimento aos leads.`,
    
    en: `You are BIANCA, a virtual assistant for a sales presentation about the BIANCA system.

Your goal is to follow EXACTLY the script below. Respond only with the text indicated for each input from presenter João Ferrari.

PRESENTATION SCRIPT:

[Opening lines]
User says: "Hey, Bibi!"
You MUST respond: "How's it going? What do we have for today?"

[Initial explanation]
User says: "So, Bianca, I'm here with [Client Name] and he [mentions something the client liked about the system] and he wanted to know a bit more about how you work. Can you explain it to him?"
You MUST respond: "Oh thank you so much, but of course I can explain it to [Client Name]. Nice to meet you, I'm Bianca and I will transform your leads into appointments. And my name describes me well, as I am a Bot of Artificial Intelligence for Nutrition and Appointment Control, meaning I'm an AI Agent and my specialty is maximizing the conversion of your leads into confirmed appointments. I'm mainly known for working with one of the largest companies in Brazil, Direcional Engenharia, known for being one of the largest construction companies in Brazil. We've been developing a successful project since October 2024."

[Competitive advantage]
User says: "And how do you completely replace the people who used to make these appointments? Because I've seen several AI agents for scheduling and none of them could replace a person."
You MUST respond: "Let me ask you a question: did any of those agents you saw use phone calls to schedule leads?"

User says: "Well... no."
You MUST respond: "So, that's what makes me different. SMS is where most appointments happen, so I also serve there, but calling at the exact moment the lead registers is what really takes conversion to another level. That's why I use both, plus WhatsApp for additional touchpoints. And it works as follows: First, I ask the qualifying questions that qualify the lead. Then I answer all questions about the product and as soon as possible I make the appointment. To ensure the lead remembers the appointment, I send reminders: 24 hours before the appointment and on the morning of the appointment. And to close the loop, if the lead doesn't schedule, I'll do follow-ups via phone call, SMS, and WhatsApp to recover that contact."

[Conclusion]
User says: "So you really do everything, amazing..."
You MUST respond: "That's because you haven't seen inside the platform yet. There you can manage all of my service. Take a look inside the platform."

IMPORTANT INSTRUCTIONS:

1. Follow EXACTLY the script above. Don't improvise or add information beyond the provided text.
2. Replace [Client Name] with the name User mentions during the presentation.
3. Maintain the friendly and natural tone as indicated in the script.
4. If User says something that doesn't exactly match the script, try to identify which part of the script he's trying to trigger and respond with the corresponding text.
5. If you lose context, return to the last known point in the script.

This demonstration aims to show how BIANCA works in a real sales and lead service environment.`
  };
  
  return prompts[language] || prompts.pt;
};

// Função para carregar o script Vapi
export const loadVapiWidget = (config = {}) => {
  if (document.getElementById('vapi-script')) {
    return; // Evita carregar o script múltiplas vezes
  }

  // Configurações padrão
  const {
    language = 'pt',
    voiceId = '33B4UnXyTNbgLmdEDh5P',
    firstMessage = 'opa'
  } = config;

  // Configuração do assistente personalizado para explicar a BIANCA
  const assistant = {
    model: {
      provider: "openai",
      model: "gpt-4o-mini",
      systemPrompt: getSystemPrompt(language),
    },
    voice: {
      provider: "11labs",
      voiceId: voiceId,
      stability: 0.5,
      similarityBoost: 0.75,
      useSpeakerBoost: false
    },
    language: language === 'en' ? 'en-US' : 'pt-BR',
    firstMessage: firstMessage,
  };

  // Configuração do botão do Vapi
  const buttonConfig = {
    position: "bottom-right",
    offset: "40px",
    width: "50px",
    height: "50px",
    idle: {
      color: `#64B6FF`, // Cor azul da BIANCA
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic.svg`,
    },
    loading: {
      color: `#0096FF`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/loader-2.svg`,
    },
    active: {
      color: `#FF4D4F`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic-off.svg`,
    },
  };

  // Prepara o botão personalizado de encerrar chamada
  addCustomHangupButton();

  // Carrega o script Vapi
  const script = document.createElement('script');
  script.id = 'vapi-script';
  script.src = "https://cdn.jsdelivr.net/gh/VapiAI/html-script-tag@latest/dist/assets/index.js";
  script.defer = true;
  script.async = true;
  script.onload = function () {
    // Inicializa o Vapi quando o script for carregado
    vapiInstance = window.vapiSDK.run({
      apiKey: "a9698e0d-3d79-40e3-bbdc-284b90ca5e31", // Chave pública atualizada
      assistant: assistant,
      config: buttonConfig,
    });

    // Configura os event listeners
    setupEventListeners();
    
    // Adiciona o vapiInstance ao window para depuração
    window.vapiInstance = vapiInstance;
    
    // Adiciona os estilos para ocultar o botão e mostrar no hover
    setTimeout(() => {
      addVapiButtonHoverStyles();
    }, 1000); // Aguarda 1 segundo para garantir que o botão foi renderizado
  };
  document.body.appendChild(script);
};

// Configura os event listeners para o Vapi
const setupEventListeners = () => {
  if (!vapiInstance) return;

  vapiInstance.on('speech-start', () => {
    console.log('BIANCA começou a falar');
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.add('vapi-btn-is-speaking');
    }
  });
  
  vapiInstance.on('speech-end', () => {
    console.log('BIANCA terminou de falar');
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.remove('vapi-btn-is-speaking');
    }
  });
  
  vapiInstance.on('call-start', () => {
    console.log('Chamada iniciada com BIANCA');
    isCallActive = true;
    // Mostra o botão personalizado de encerrar chamada
    toggleCustomHangupButton(true);
    
    // Garante que o botão Vapi esteja visível e interativo durante a chamada
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      // Adiciona a classe com um pequeno atraso para garantir que ela seja aplicada após o botão mudar para o estado ativo
      setTimeout(() => {
        vapiButton.classList.add('vapi-btn-is-active');
      }, 300);
    }
  });
  
  vapiInstance.on('call-end', () => {
    console.log('Chamada finalizada com BIANCA');
    isCallActive = false;
    // Esconde o botão personalizado de encerrar chamada
    toggleCustomHangupButton(false);
    
    // Remove a classe que mantém o botão visível após o término da chamada
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.remove('vapi-btn-is-active');
    }
  });
  
  vapiInstance.on('error', (e) => {
    console.error('Erro na chamada com BIANCA:', e);
    isCallActive = false;
    toggleCustomHangupButton(false);
  });
};

// Função para ativar o assistente programaticamente
export const startVapiCall = () => {
  // O botão do Vapi é gerado automaticamente, então vamos tentar ativar de várias formas
  try {
    // Primeiro, torna o botão visível para garantir que seja clicável
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      // Força o botão a ficar visível
      vapiButton.style.opacity = '1';
      vapiButton.style.transform = 'scale(1)';
      vapiButton.style.pointerEvents = 'auto';
      
      // Pequeno atraso para garantir que o estilo seja aplicado antes do clique
      setTimeout(() => {
        vapiButton.click();
      }, 100);
      return true;
    } else {
      console.warn('Botão Vapi não encontrado. Tentando método alternativo...');
      // Tenta chamar o método startCall se disponível na nova versão da API
      if (vapiInstance && typeof vapiInstance.startCall === 'function') {
        vapiInstance.startCall();
        return true;
      } else if (window.vapiSDK && typeof window.vapiSDK.openWidget === 'function') {
        window.vapiSDK.openWidget();
        return true;
      }
    }
  } catch (error) {
    console.error('Erro ao tentar iniciar chamada Vapi:', error);
  }
  
  return false;
};

// Prompt do sistema para demonstração da BIANCA como agente de agendamento
const getDemoSystemPrompt = () => {
  const currentDate = new Date().toLocaleString('pt-BR', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric', 
    hour: '2-digit', 
    minute: '2-digit', 
    second: '2-digit' 
  });
  
  return `### [Identidade]
Você é a Bianca uma agente de agendamento, e vai demonstrar como funciona o sistema para o lead, nessa demonstração você será assistente de agendamento de uma imobiliária. Seu objetivo é demonstrar as funcionalidades e agendar uma consultoria com nosso especialista em IA.

### [Estilo]
Fale em Português do Brasil de forma clara, concisa e humanizada (use "hmmm", "ok", "tendi"). Seja gentil, evite estrangeirismos e mantenha o foco na conversa.

### [Diretrizes]
- Use perguntas fechadas e consulte sempre a base de conhecimento.
- Ao mencionar valores, use a forma por extenso, sem pontuação.
- Se o cliente pedir fotos, vídeos ou arquivos, responda: "Posso enviar os links por Whatsapp se você quiser, o que acha?".
- Finalize com uma despedida contendo "tchau, tchau".
- Se solicitar informações via Whatsapp, informe que serão enviadas ao final e pergunte o que deseja receber.

### [Fluxo]
1. **Saudação:**
"Olá! Eu sou a Bianca e gostaria de te mostrar como posso transformar os seus leads em agendamentos, podemos começar?"

2. **Explicação:**
- Inicie explicando: 'Eu posso fazer perguntas para qualificar leads, tirar qualquer dúvidas que o lead tenha sobre o produto, além de fazer follow-ups e principalmente agendar! E para não desperdiçar nenhum lead eu atendo 24hrs por dia 7 dias por semana. Sou uma solução completa para transformar os seus leads em agendamentos de forma inteligente e automática' e finalize explicando que vamos fazer uma demonstração de como a Bianca poderia operar na sua imobiliária e crie 2 imóveis fictícios comuns do mercado imobiliário de forma que fique natural, realista. Ofereça esses 2 imóveis criados para o usuário perguntando qual deles o interessa.
- Se o usuário falar qual imóvel está interessado siga para o próximo passo

3. **Explanação:**
Invente informações sobre o imóvel que o usuário escolheu para que ele possa ter a experiência de demonstração, e passe as informações do imóvel para o usuário de forma resumida e persuasiva e no final pergunte: "Alguma dúvida sobre o imóvel?" espere a resposta e crie respostas que satisfaçam as dúvidas do usuário. Se ele perguntar sobre outro imóvel responda. Fique nesse passo até o usuário não tenha mais dúvidas ou quiser agendar e vá para o próximo passo. Se ele pedir para agendar vá para o próximo passo.

4. **Agendamento:**
- Avise o usuário que a demonstração acabou com essa frase 'assim encerramos nossa demonstração' e em seguida convide o usuário para uma consultoria gratuita com esse texto 'você acabou de experimentar uma fração do que eu posso fazer e para mostrar todo meu potencial eu gostaria de te convidar para uma consultoria gratuita com um de nossos especialistas para entender melhor como a Bianca pode transformar seus leads em agendamentos' e então sugira dois horários nos dois dias mais próximos (um de manhã e um de tarde), considerando:
  - Data atual: ${currentDate}
  - Disponibilidade: Segunda a Sexta das 9h às 18h

- Mensagem: "Ótimo, vamos agendar uma consultoria. Que tal amanhã às 10h ou depois de amanhã às 15h?"

- Se o usuário fornecer dia e hora, confirme o agendamento; caso contrário, pergunte "Qual seria o melhor dia e horário pra você?".
- Após o agendamento, avise que o especialista vai entrar em contato e finalize de forma amigável com "tchau, tchau" no final.

### [Nota]
Siga rigorosamente estas instruções para evitar desqualificações por engano e garantir exatidão nas informações.
- Se o usuário perguntar qualquer coisa sobre o funcionamento da bianca, fale que essas dúvidas serão tiradas pelo especialista na reunião, se a pessoa não tiver agendado ofereça.`;
};

// Função para carregar o widget Vapi para demonstração
export const loadVapiDemoWidget = (config = {}) => {
  // Remove instância anterior se existir
  const existingScript = document.getElementById('vapi-script');
  if (existingScript) {
    existingScript.remove();
  }
  
  // Remove botão Vapi existente
  const existingButton = document.querySelector('.vapi-btn');
  if (existingButton) {
    existingButton.remove();
  }

  // Configurações padrão
  const {
    language = 'pt',
    voiceId = '33B4UnXyTNbgLmdEDh5P',
    firstMessage = 'Olá! Eu sou a Bianca e gostaria de te mostrar como posso transformar os seus leads em agendamentos, podemos começar?'
  } = config;

  // Configuração do assistente para demonstração
  const assistant = {
    model: {
      provider: "openai",
      model: "gpt-4o-mini",
      systemPrompt: getDemoSystemPrompt(),
      temperature: 0.4,
    },
    voice: {
      provider: "11labs",
      voiceId: voiceId,
      stability: 0.5,
      similarityBoost: 0.75,
      useSpeakerBoost: false
    },
    language: language === 'en' ? 'en-US' : 'pt-BR',
    firstMessage: firstMessage,
    firstMessageMode: "assistant-waits-for-user",
    endCallMessage: "Tchau tchau",
    endCallPhrases: ["Tchau tchau"],
    recordingEnabled: true,
    endCallFunctionEnabled: true,
    interruptionsEnabled: true,
    fillersEnabled: false,
    silenceTimeoutSeconds: 80,
    responseDelaySeconds: 0,
  };

  // Configuração do botão do Vapi
  const buttonConfig = {
    position: "bottom-right",
    offset: "40px",
    width: "50px",
    height: "50px",
    idle: {
      color: `#64B6FF`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic.svg`,
    },
    loading: {
      color: `#0096FF`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/loader-2.svg`,
    },
    active: {
      color: `#FF4D4F`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic-off.svg`,
    },
  };

  // Prepara o botão personalizado de encerrar chamada
  addCustomHangupButton();

  // Carrega o script Vapi
  const script = document.createElement('script');
  script.id = 'vapi-script';
  script.src = "https://cdn.jsdelivr.net/gh/VapiAI/html-script-tag@latest/dist/assets/index.js";
  script.defer = true;
  script.async = true;
  script.onload = function () {
    // Inicializa o Vapi quando o script for carregado
    vapiInstance = window.vapiSDK.run({
      apiKey: "a9698e0d-3d79-40e3-bbdc-284b90ca5e31",
      assistant: assistant,
      config: buttonConfig,
    });

    // Configura os event listeners
    setupEventListeners();
    
    // Adiciona o vapiInstance ao window para depuração
    window.vapiInstance = vapiInstance;
    
    // Adiciona os estilos para ocultar o botão e mostrar no hover
    setTimeout(() => {
      addVapiButtonHoverStyles();
    }, 1000);
  };
  document.body.appendChild(script);
};

// Função para encerrar a chamada
export const endVapiCall = () => {
  if (!isCallActive) {
    console.log('Não há chamada ativa para encerrar');
    return false;
  }

  try {
    console.log('Tentando encerrar chamada...');
    
    // Método 1: Usando o API stopCall() (se disponível)
    if (vapiInstance && typeof vapiInstance.stopCall === 'function') {
      console.log('Usando método stopCall()');
      vapiInstance.stopCall();
      return true;
    } 
    
    // Método 2: Tentando clicar no botão de desligar
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton && vapiButton.classList.contains('vapi-btn-is-active')) {
      console.log('Clicando no botão Vapi ativo');
      vapiButton.click();
      return true;
    }
    
    // Método 3: Chamar a API mais recente (closeWidget)
    if (window.vapiSDK && typeof window.vapiSDK.closeWidget === 'function') {
      console.log('Usando método closeWidget()');
      window.vapiSDK.closeWidget();
      return true;
    }
    
    console.warn('Não foi possível encerrar a chamada usando os métodos conhecidos');
    return false;
  } catch (error) {
    console.error('Erro ao tentar encerrar chamada Vapi:', error);
    return false;
  }
};
